import Dialog from '@mui/material/Dialog';
import { Form, Formik, FormikHelpers } from 'formik';
import { CourseFormValues } from 'src/models/Course.model';
import { useAddCourseMutation } from 'src/services/CourseServices';
import { showToast } from 'src/utils/showToaster';
import { array, number, object, string } from 'yup';
import CourseForm from '../Layouts/CourseForm';

type Props = {
  onClose: () => void;
};

const AddCourseFormWrapper = ({ onClose }: Props) => {
  const [addCourse] = useAddCourseMutation()
  
  // Form Initial Values
  const initialValues: CourseFormValues = {
    courseName:"",
    courseDescription:"",
    moduleId:[],
    classroomFees:"",
    onlineFees:""
  };

  // Validation Schema
  const validationSchema = object().shape({
    courseName: string().required('Please enter course name'),
    courseDescription: string().required('Please enter course description'),
    moduleId: array().min(1,"Please select modules").required('Please select modules'),
    classroomFees: number().typeError("Please enter valid fees").required('Please enter fees'),
    onlineFees: number().typeError("Please enter valid fees").required('Please enter fees'),
  });

  // Handle Submit
  const handleSubmit = (
    values: CourseFormValues,
    { setSubmitting, resetForm }: FormikHelpers<CourseFormValues>
  ) => {
    const formattedValues={
      ...values,
      moduleId:values?.moduleId?.map((module)=>module?.value)
    }
     addCourse(formattedValues).then((res: any) => {
       if (res?.error) {
         showToast('error', res?.error?.data?.message);
       } else {
         if (res?.data?.status) {
           showToast('success', res?.data?.message);
           resetForm();
           onClose();
         } else {
           showToast('error', res?.data?.message);
         }
       }
       setSubmitting(false);
     })
  };

  return (
    <Dialog open maxWidth='xs' fullWidth>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <CourseForm formikProps={formikProps} onClose={onClose} formType='Add'/>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default AddCourseFormWrapper;